import { jsx as _jsx } from "react/jsx-runtime";
import './styles.scss';
const FooterUI = () => {
    return (_jsx("div", Object.assign({ className: 'footer' }, { children: _jsx("p", { children: " \u00A9 DERECHOS RESERVADOS EL REFUGIO CONDOMINIO 2022" }) })));
};
export default FooterUI;
